import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Text } from '@common-fe/common-fe';

import { DismissedBannerKey } from '@/common/constants';
import theme from '@/styles/theme';

import SeeWhatsNewPopup from './SeeWhatsNewPopup';

interface Props {
  dismissBanner?: (bannerKey: DismissedBannerKey) => void;
}

const SeeWhatsNewButton: React.FC<Props> = ({ dismissBanner }) => {
  const { t } = useTranslation();
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const handleOpenPopup = useCallback(() => {
    setIsPopupVisible(true);
  }, []);

  return (
    <>
      <AppButton
        testId="see-whats-new_button"
        onClick={handleOpenPopup}
        style={{
          background: theme.colors.navigationAccent2,
          borderRadius: '60px',
          height: '32px'
        }}
      >
        <Text color="textBody" weight={400}>
          {t("See What’s New!")}
        </Text>
      </AppButton>

      {isPopupVisible && (
        <SeeWhatsNewPopup
          onSetVisible={setIsPopupVisible}
          dismissBanner={dismissBanner}
        />
      )}
    </>
  );
};

export default SeeWhatsNewButton;
